<template>
    <div>
      <select ref="select" class="select" :class="[sizeClass]" v-bind="$attrs" v-model="computedValue" :multiple="multiple">
        <option v-if="placeholder && !computedValue" value="" disabled hidden>
          {{ placeholder }}
        </option>

        <slot />
      </select>
    </div>
  </template>
  
  <script>
    import FormElementMixin from '@mixins/formElementMixin';
    export default {
      name: 'DSelect',

      mixins: [FormElementMixin],
      inheritAttrs: false,

      props: {
        modelValue: {
          type: [String, Number, Boolean, Object, Array, Symbol, Function],
          default: null,
        },
        placeholder: String,
        multiple: Boolean,
        size: {
          type: String,
          default: 'md',
          validator: (value) => ['xs', 'sm', 'md', 'lg', 'xl'].includes(value),
        },
      },

      emits: ['update:modelValue'],

      computed: {
        computedValue: {
          get() {
            return this.modelValue;
          },
          set(value) {
            this.$emit('update:modelValue', value);
            !this.isValid && this.checkHtml5Validity();
          },
        },

        sizeClass() {
          let className = '';
          switch (this.size) {
            case 'xs':
              className = 'select-xs';
              break;
            case 'sm':
              className = 'select-sm';
              break;
            case 'md':
              className = 'select-md';
              break;
            case 'lg':
              className = 'select-lg';
              break;
            case 'xl':
              className = 'select-xl';
              break;

            default:
              className = 'select-md';
              break;
          }

          return className;
        }
      },
    };
  </script>